import { Component, Input, OnInit, OnDestroy, Type } from '@angular/core';
import { IGetClass, IModalWindow, ISetOptions } from '../../../utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from '../../../core/enums';
import { CurrentDialogEnum } from '../../../utils/enums/current-dialog.enum';
import { CloudDlgManagerService } from '../../../services/cloud-storage/cloud-dlg-manager.service';
import { Subscription } from 'rxjs';
import { FileMoveDialogComponent } from '../file-move-dialog/file-move-dialog.component';
import { CloudStorageDialogComponent } from '../cloud-storage-dialog/cloud-storage-dialog.component';



@Component({
    selector: 'asg-file-manager-dialog',
    templateUrl: './file-manager-dialog.component.html',
    styleUrls: ['./file-manager-dialog.component.scss'],
    standalone: true,
    imports: [CloudStorageDialogComponent, FileMoveDialogComponent]
})
export class FileManagerDialogComponent implements OnInit, OnDestroy, ISetOptions {
  @Input() ok: () => void;
  @Input() no: () => void;
  currentDialogEnum: typeof CurrentDialogEnum = CurrentDialogEnum;
  currentDialog: CurrentDialogEnum = CurrentDialogEnum.CloudStorageDlg;

  reopened: boolean;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private cloudManager: CloudDlgManagerService
  ) {
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.initSubscriptions();

    if (!this.reopened) {
      this.cloudManager.clearFolderHistory();
    }
  }

  initSubscriptions(): void {
    this.subscriptions.add(
      this.cloudManager.UpdateComponent.subscribe((component) => {
        this.currentDialog = component;
      }),
    );
  }

  getClass(): string {
    return 'cloud-storage-dlg';
  }

  getWindowType(): Type<IModalWindow> {
    return FileManagerDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.FILE_MANAGER_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | ISetOptions | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  // TODO: specify proper type here
  setOptions(options: any): void {
    options = options || {};
    this.reopened = options.reopened;
  }
}
